/**
 * Authors: mariushirjanu
 * Created: 03/03/2021
 */
import { Injectable } from '@angular/core';

import { HttpDataService, IHttpDataCache } from '../../http/http-data.service';
import { ICodeValue } from '../../../../type_definitions/datatypes';

export const EXTENDED_PAYMENT_TERMS:string = 'PAYTERMS';

@Injectable()
export class TCDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    private httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public getTC(chargeGroup:string):Promise<ICodeValue[]> {
    return this.cache.doGET(
      'rest/termsandconditions',
      { chargeGroup },
      undefined,
      'Error loading terms'
    );
  }

  public clear():void {
    this.cache.clear();
  }
}